import { gql } from '@apollo/client';
const SET_WAREHOUSE_RELEASE_MODEL_TO_READY = gql `
  mutation SetWarehouseReleaseModelToReady($warehouseReleaseModelId: String!) {
    setWarehouseReleaseModelToReady(warehouseReleaseModelId: $warehouseReleaseModelId) {
      warehouseReleaseModel {
        id
      }
    }
  }
`;
export default SET_WAREHOUSE_RELEASE_MODEL_TO_READY;
